import { styled } from '@mui/material/styles';

export const LayoutContainer = styled('div')(() => ({
  display: 'flex',
  minHeight: '100vh',
  backgroundColor: '#f8f9fa',
}));

export const MainContainer = styled('main')(() => ({
  flex: 1,
  marginLeft: '250px',
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',

  '@media (max-width: 768px)': {
    marginLeft: 0,
  },
}));